import { type SVGProps } from "react";

export default function OpenMatchIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      {/* Chat bubble */}
      <path d="M8.5 3h7a2 2 0 0 1 2 2v2.5a2 2 0 0 1-2 2H14l-2 2-2-2H8.5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z" />
      {/* Left person: head + shoulder arc */}
      <circle cx="7.5" cy="16" r="2" />
      <path d="M3 22c0-2.5 2-4.5 4.5-4.5S12 19.5 12 22" />
      {/* Right person: head + shoulder arc */}
      <circle cx="16.5" cy="16" r="2" />
      <path d="M12 22c0-2.5 2-4.5 4.5-4.5S21 19.5 21 22" />
    </svg>
  );
}
